
export function getAddressPropOrder() {
    return [ 'country', 'street', 'aptSuiteOrUnit', 'city', 'state', 'zipCode' ];
}
